import React, { Component } from 'react';

import { BrowserRouter, Route } from 'react-router-dom';
import './App.css';


import Navbar from './components/Navbar';
import Carousel from './components/Carousel';

import Home from './pages/Home';
import Research from './pages/Research';
import Education from './pages/Education';
import Scholarship from './pages/Scholarship';
class App extends Component {
  render() {
    return (
      <div className="container" style={{fontFamily:"Muli, Niramit, 'Indie Flower'"}}>
        <BrowserRouter>
          <div>
            <Navbar />
            <Carousel />
            <Route exact path="/" component={Home} />
            <Route exact path="/" component={Education} />
            <Route exact path="/" component={Scholarship} />
            <Route exact path="/" component={Research} />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
